import React from 'react';
import { Tag, Tooltip } from 'antd';
import { truncateByLength } from '../common/helper';
import { legacyBorder } from '@/utils/legacyColor';

const OUTER_BORDER = legacyBorder('2px solid #E8E8E8');

interface TeamInfo {
  name: string;
  role_name?: string;
  color?: string;
}

interface TeamsTagProps {
  teamData: Record<string, TeamInfo>;
  border?: boolean;
  padding?: boolean;
  flexWrap?: React.CSSProperties['flexWrap'];
  highlightRole?: boolean;
  maxTruncate?: number;
}

const TeamsTag: React.FC<TeamsTagProps> = ({
  teamData,
  border = true,
  padding,
  flexWrap = 'wrap',
  highlightRole = false,
  maxTruncate = 20,
}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        gap: '4px',
        flexWrap: flexWrap,
        padding: padding === false ? '2px -1px 2px 8px' : '2px 40px 2px 8px',
        border: border ? OUTER_BORDER : 'none',
        borderRadius: '8px',
      }}
    >
      {Object.entries(teamData).map(([team, info]) => {
        if (!info?.role_name) return null;

        const isTruncated =
          info.name.length > maxTruncate || info.role_name.length > maxTruncate;

        const displayName = truncateByLength(info.name, maxTruncate);
        const displayRole = truncateByLength(info.role_name, maxTruncate);

        const content = highlightRole ? (
          <span
            style={{
              color: 'var(--text-primary)',
              fontWeight: 700,
            }}
          >
            {displayName} :{' '}
            <span
              style={{
                color: 'var(--text-primary)',
                fontWeight: 700,
              }}
            >
              {displayRole}
            </span>
          </span>
        ) : (
          <span>
            {displayName} : {displayRole}
          </span>
        );

        return (
          <Tag
            key={team}
            style={{
              backgroundColor: 'var(--surface-container)',
              color: 'var(--text-secondary)',
              fontSize: '10px',
              fontWeight: '600',
              borderRadius: '4px',
              padding: '4px 6px',
              border: '1px solid var(--gray-300)',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              margin: '4px',
              height: '20px',
            }}
          >
            <span
              style={{
                width: '10px',
                height: '10px',
                backgroundColor: info.color,
                borderRadius: '50%',
                display: 'inline-block',
              }}
            ></span>
            {isTruncated ? (
              <Tooltip title={`${info.name}: ${info.role_name}`}>
                {content}
              </Tooltip>
            ) : (
              content
            )}
          </Tag>
        );
      })}
    </div>
  );
};

export default TeamsTag;
